import { Button } from 'app/components/ui/Button'
import { Modal } from 'app/components/ui/Modal'
import { Text } from 'app/components/ui/Text'
import { useDeleteSponsorshipProofs } from 'app/queries/sponsorRequests'
import { theme } from 'app/styles/themeEstra'
import _ from 'lodash'
import React, { useEffect } from 'react'

import {
  ActionsWrapper,
  DeleteButton,
  Proof,
  ProofDate,
  ProofImage,
  ProofName,
  ProofWrapper,
  ImageWrapper,
} from './styled'
import { ProofFileListProps } from './types'
import { formatDate, formatFileName } from './utils'

const ProofFileList = ({
  sponsorRequest,
  isDeleteModalOpen,
  closeDeleteModal,
  refetchSponsorRequest,
  openDeleteModal,
}: ProofFileListProps): JSX.Element => {
  const { isSuccess, mutate: deleteSponsorshipProof } =
    useDeleteSponsorshipProofs()

  useEffect(() => {
    if (isSuccess) {
      refetchSponsorRequest()
    }
  }, [isSuccess, refetchSponsorRequest])

  return (
    <>
      {!_.isEmpty(sponsorRequest.sponsorship_proofs) && (
        <>
          <Text variant='s18' weight='bold'>
            Giustificativi inseriti
          </Text>
          <ProofWrapper>
            {sponsorRequest.sponsorship_proofs?.map((proof, i) => {
              return (
                <>
                  {isDeleteModalOpen[proof.id] && (
                    <Modal
                      title='Elimina file'
                      onCloseRequest={() => closeDeleteModal(proof.id)}
                    >
                      <Text variant='s16'>
                        Sei sicuro di voler eliminare il file{' '}
                        <b>{formatFileName(proof.name)}</b>?
                      </Text>
                      <ActionsWrapper>
                        <Button
                          variant='grey'
                          onClick={() => {
                            closeDeleteModal(proof.id)
                          }}
                        >
                          Annulla
                        </Button>
                        <Button
                          onClick={() => {
                            deleteSponsorshipProof({
                              sponsor_request_id: sponsorRequest.id,
                              sponsorship_proof_id: proof.id,
                            })
                            refetchSponsorRequest()
                            closeDeleteModal(proof.id)
                          }}
                        >
                          Conferma
                        </Button>
                      </ActionsWrapper>
                    </Modal>
                  )}
                  <Proof key={proof.name + i}>
                    <ImageWrapper>
                      <a
                        href={proof.url || ''}
                        target='_blank'
                        rel='noreferrer'
                        style={{ color: theme.color.primari.neroEstra }}
                      >
                        <ProofImage src={proof.url} type={proof.name} />
                      </a>
                    </ImageWrapper>
                    <ProofName>
                      <a
                        href={proof.url || ''}
                        target='_blank'
                        rel='noreferrer'
                        style={{ color: theme.color.primari.neroEstra }}
                      >
                        <Text variant='s12'>{formatFileName(proof.name)}</Text>
                      </a>
                      <Text variant='s12' color='#7F8FA4'>
                        {proof.filesize ||
                          'Non è disponibile la dimensione del file'}
                      </Text>
                    </ProofName>
                    <ProofDate>
                      <Text variant='s16' color='#7F8FA4' weight='600'>
                        Caricato il {formatDate(proof.created_at)}
                      </Text>
                    </ProofDate>
                    <DeleteButton
                      onClick={(e: React.MouseEvent) => {
                        e.stopPropagation()
                        openDeleteModal(proof.id)
                      }}
                    />
                  </Proof>
                </>
              )
            })}
          </ProofWrapper>
        </>
      )}
    </>
  )
}

export default ProofFileList
